import React from 'react'
import {
	Prompt,
	Link
} from 'react-router-dom'
import PropTypes from 'prop-types'
// import queryString from 'query-string'
import bindAll from 'lodash/bindAll'
import { Form } from 'formik'
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'

import DateMeta from '@components/DateMeta/DateMeta'
import DataExportButton from '@components/DataExportButton/DataExportButton'
import { Debug } from '@components/Debug/Debug'
import { FormGroup } from '@modules/form/form.module'
import Loading from '@components/Loading/Loading'
import PageHeaderSticky from '@components/PageHeaderSticky/PageHeaderSticky'

// TODO: import all statuses in a bundle
import jobStatuses from '@server/constants/statuses/job-statuses'

import './Singular.scss'

const urlPropsQueryConfig = {
	edit: { type: UrlQueryParamTypes.string },
}

export default 
@addUrlProps({ urlPropsQueryConfig })
class Singular extends React.Component {

	static propTypes = {
		resource: PropTypes.string.isRequired,
		formConfig: PropTypes.arrayOf(PropTypes.shape({
			label: PropTypes.string,
			fields: PropTypes.arrayOf(PropTypes.shape({
				label: PropTypes.string,
				name: PropTypes.string,
			}))
		})),
		renderForm: PropTypes.func,
		renderAfterForm: PropTypes.func,
		// TODO: add renderForm
		createdString: PropTypes.string,
		editedString: PropTypes.string,
		approvedString: PropTypes.string,
		mapDataToCSV: PropTypes.func,
		displayAsAccordion: PropTypes.bool,
		supportsDeleting: PropTypes.bool,
		supportsNotes: PropTypes.bool,
	};

	static defaultProps = {
		createdString: 'Created',
		editedString: 'Last Edited',
		loginString: 'Last Successful Login',
		approvedString: 'Approved',
		displayAsAccordion: false,
		supportsDeleting: false,
	};

	constructor(props) {
		super(props);

		// check query prop for auto-starting edit
		// TODO: make /edit an actual route?
		if (props.edit === 'true') {
			this.props.history.replace(this.props.location.pathname, this.props.location.state);
			this.startEdit();
		}

	}

	componentWillUnmount() {
		const { isEditing, editOnly, toast, actions } = this.props;
		// Wip/reset state if not saved and component is unmounting
		if (isEditing && !editOnly)
			actions.editCancel();

		toast.clean();
	}

	componentDidUpdate() {
		if (this.props.isNew && this.props.data && this.props.data.id) {
			this.props.history.push(`/${this.props.resource}/${this.props.data.id}`);
		}
	}

	// Actions

	startEdit = (e) => {
		// clear any notications when starting edit
		this.props.toast.clean();
		// // dispatch edit mode start
		this.props.actions.editStart();
	};

	cancelEdit = (e) => {
		// dispatch cancel edit action
		this.props.actions.editCancel();
		// reset form changes
		this.props.resetForm();
	};


	delete = async () => {
		const { resource, setFieldValue, submitForm, history, location } = this.props;
		console.log(this.props);
		// confirm user intent
		const confirmed = window.confirm(`Are you sure you want to delete this ${resource}?`);
		// bail if cancelled
		if (!confirmed) return false;
		// set status to deleted
		// TODO: use lookup table of all resource statuses rather than jobStatuses (currently only jobs support deleting)
		if (resource === 'job') {
		await setFieldValue('status', jobStatuses.find(s => s.key === 'deleted'));; // set status to deleted
		await submitForm();
		}

		else {
			 fetch(`/api${location.pathname}`, { // '/' removed after /api
				method: 'DELETE'
			  })
			  .then(res => res.json())
			}
			await history.push(`/${resource}s`)
			alert(`${resource} deleted!`)
	};

	// Test for visible errors
	// TODO: abstract this function somewhere
	hasVisibleErrors(errors = {}, touched) {

		function checkForVisibleErrors(errors, touched = {}) {

			var errorEntries = Object.entries(errors);

			if (!errorEntries.length)
				return false;

			// TODO: make recursive?
			var visibleErrors = false;

			for (var [key, value] of errorEntries) {

				var visible = typeof value === 'object'
					? checkForVisibleErrors(value, touched[key])
					: key in touched;

				if (visible) {
					visibleErrors = true;
					break;
				}

			}

			return visibleErrors;

		}

		return Object.keys(errors).length
			? checkForVisibleErrors(errors, touched)
			: false;

	}

	// Event Handlers

	handleEnter = (e) => {
		if (e.key === 'Enter') {
			var type = e.target.getAttribute('type');
			if(type === 'text' ) { // TODO: extend this to other types?
				if(this.props.dirty) {
					this.props.submitForm();
				}
				else if (this.isEditing && !this.props.editOnly) {
					this.cancelEdit();
				}
			}
		}
	}

	async handleSubmit(e) {

		const { values, submitForm, setSubmitting } = this.props;
		const _uploads = values._uploads || [];

		// set submitting to block multiple submit attempts
		setSubmitting(true);

		// wait for file uploads to finish
		await Promise.all(_uploads);

		// submit form
		submitForm(e);

	}

	get isEditing() {
		const { isEditing, editOnly } = this.props;
		return editOnly || isEditing;
	}

	render() {

		var {
			data,
			// formik props
			dirty,
			editOnly,
			renderForm,
			renderAfterForm,
			formConfig,
			values,
			errors,
			touched,
			isSubmitting,
			submitForm,
			isNew,
			displayAsAccordion,
			title,
			mapDataToCSV,
			mapDataToCSVFilename,
			//
			supportsNotes,
			supportsDeleting,
			resource,
			match
		} = this.props;

		const { isEditing } = this;

		// protect against null data			
		data = data ? data : {};

		title = typeof title === 'function' ? title(data) : title;

		var hasVisibleErrors = this.hasVisibleErrors(errors, touched);
		var submittable = !isSubmitting && dirty;

		return !values || !Object.keys(values).length
			? <Loading isLoading={true} />
			: (
				<main className="Singular page-content">
					<Prompt
						when={isEditing && dirty ? true : false}
						message={location => `Changes will be lost if you navigate away\n\nare you sure you want to leave this page?`}
					/>
					<PageHeaderSticky title={title}>
						{
							isEditing &&
							<button type="submit" data-errors-visible={hasVisibleErrors} onClick={submitForm} disabled={!submittable}>Submit</button>
						}
						{
							isEditing && data && data.id && !editOnly &&
							<button type="cancel" className="btn btn-primary" onClick={this.cancelEdit} >Cancel</button>
						}
						{
							!isEditing &&
							<button type="edit" className="btn btn-primary" onClick={this.startEdit}>Edit</button>
						}
						{
							supportsNotes && !isNew && !isEditing
							&& <Link to={`/${resource}/${match.params.id}/notes`}><button type="button" className="btn btn-primary">Notes</button></Link>
						}
						{
							mapDataToCSV && !isNew && !isEditing &&
							<DataExportButton
								className="btn btn-primary"
								data={data}
								mapDataToCSV={mapDataToCSV}
								mapDataToCSVFilename={mapDataToCSVFilename}
							/>
						}
						{
							data && data.id && supportsDeleting &&
							<button type="button" className="btn btn-primary" onClick={this.delete}>Delete</button>
						}
						{
							// hasVisibleErrors Hint
							hasVisibleErrors
							&& <div className="ErrorMessage">Cannot submit with errors on the page</div>
						}
					</PageHeaderSticky>


					<section className="PageContent">

						<Form onKeyPress={this.handleEnter} autoComplete="off">
							{
								renderForm
									? typeof renderForm === 'function' ? renderForm(this.props) : renderForm
									: formConfig.map((group, i) => {
										const display = !group.showOnNewOnly || (group.showOnNewOnly && isNew);
										return display
											? <FormGroup
												key={i}
												{...group}
												values={values}
												isEditing={isEditing}
												isNew={isNew}
												collapsible={displayAsAccordion}
												collapsed={Boolean(i)}
											/>
											: ''
									})
							}
							{renderAfterForm && (
								typeof renderAfterForm === 'function'
									? renderAfterForm(this.props)
									: renderAfterForm
							)
							}
						</Form>

						<div className="Meta">
							{/* TODO: make meta more dynamic? */}
							<DateMeta prefix={this.props.createdString} by={data.createdBy} on={data.createdAt} />
							{
								data.createdAt !== data.updatedAt && data.updatedAt
								&& <DateMeta prefix={this.props.editedString} by={data.updatedBy} on={data.updatedAt} />
							}
							<DateMeta prefix={this.props.loginString} on={data.lastLogin} />
							<DateMeta prefix={this.props.approvedString} by={data.approvedBy} on={data.approvedAt} />
						</div>

					</section>

					{ process.env.NODE_ENV === 'development' &&
						<Debug />
					}

				</main>

			)

	}


}




// WEBPACK FOOTER //
// ./src/components/Singular/Singular.jsx